export var numericProp = [Number, String];
export var unknownProp = null;
export var makeStringProp = function makeStringProp(defaultVal) {
  return {
    type: String,
    "default": defaultVal
  };
};
export var makeNumericProp = function makeNumericProp(defaultVal) {
  return {
    type: numericProp,
    "default": defaultVal
  };
};